


var CU;
var top_goal;
var mean_width;
var total_bar_width;
var group;
var app_html = '';
var wrapper_target = "CU_target_cart";
var curr_for = "amount";
// var cart_target = 'form[action="/cart"]:last, #cart';
var cart_target = 'form[action="/cart"]:last';

if(shop_url=="63d1ce.myshopify.com"){
  cart_target = "#cart-items";
}else if(shop_url=="1viytf-vf.myshopify.com"){
  cart_target = 'cart-items';
}

if(shop_url=="mollieandfred.myshopify.com"){
  cart_target = '.drawer__inner';
}

if(shop_url=="az-delivery.myshopify.com"){
  cart_target = '.cart-wrapper';
}
if(shop_url=="teregott.myshopify.com"){
  cart_target = 'cart-items';
}

// else if(shop_url=="25em99-5w.myshopify.com"){
//  cart_target = '.cart-drawer__items';
// }

var add_to_cart_tex = "Add to cart";
var current_currency_price = 1;
if( typeof Shopify !== "undefined"){
var current_currency_price = Number(Shopify.currency.rate);  
}

if(shop_url=="mollieandfred.myshopify.com"){
  current_currency_price = 1;
}




(function(url, position, callback){
    url = url || 'https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js';
    position = position || 0;
    
    if (!window.jQuery) {
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement("script");
        script.src = url;
        script.type = 'text/javascript';
        head.appendChild(script);
        head.insertBefore(script,head.childNodes[position]);
  
        script.onload = function(){
            if(typeof callback == 'function') {
                callback(jQuery);
            }
        };
    } else {
        if(typeof callback == 'function') {
            callback(jQuery);
        }
    }
}('https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js', 5, function($){

    CU = jQuery.noConflict();

    if(typeof cu_group != "undefined"){
     
          init_cu();
      
    
    }
    
}));



async function init_cu(){


 
  let real_amount_comma = "{{amount_with_comma_separator}}";

  let real_no_decimal = "{{amount_no_decimals}}";

 let real_with_comma_no_decimal ="{{amount_no_decimals_with_comma_separator}}";


  console.log(currency_format);
  console.log(progress_position);

  if(progress_position!=""){
    cart_target = progress_position;
  }
  console.log(cart_target);

  if(add_to_cart_text!=""){
    add_to_cart_tex = add_to_cart_text;
  }



  if (currency_format.includes(real_amount_comma)) {
    curr_for = "amount_with_comma_separator";
  }else if(currency_format.includes(real_no_decimal)){
    curr_for = "amount_no_decimals";

  }else if(currency_format.includes(real_with_comma_no_decimal)){
    curr_for = "amount_no_decimals_with_comma_separator";
  }

  console.log(curr_for);




if (localStorage.getItem("drawer") === "true") {
  if(window.location.href.indexOf("/cart") <= -1){
    CU("cart-drawer").addClass("active");
    localStorage.setItem("drawer", "false");
  }
}

group = JSON.parse(cu_group.replaceAll("#","'"));

var g_types = group.group_type.split(",");

if(shop_url=="firstmfgco.myshopify.com"){
  cart_total = total_price;
}

var bar_heading = create_bar_message(group, Number(cart_total));

observeCartChanges(); 

if(app_html == ""){
  app_html = CU(".CU_embed_html").html();  
}

CU(".CU_embed_html").html("");

for(var g_type of g_types){

  if(g_type == "cart" || g_type == "product"){

    if(g_type == "cart"){


      
      init_cart_bar(Number(cart_total));
    }
    

    if(g_type == "product" && window.location.href.indexOf("/product") > -1){
      
      var wrapper_target = "CU_target_product";
      var product_target = 'form[action*="/cart/add"]:last';

      if( CU(product_target).length){
        CU(product_target).append("<div class='"+ wrapper_target +"'>" + bar_heading + "</div>");  
        
      }
    
    }
      
  }

  if(g_type == "fixed_top" || g_type == "fixed_bottom"){
    CU(app_html).find('.CU_free_shipping_bar_wrapper').prependTo("body");

    if(group.sticky_top_banner && g_type == "fixed_top"){
      CU(".CU_free_shipping_bar_wrapper").addClass("top_stick");
    }else if(g_type == "fixed_bottom"){
      CU(".CU_free_shipping_bar_wrapper").addClass("bottom_stick");
    }
    
    CU(".CU_free_shipping_bar_title").html(bar_heading);
  }
  
}

  if(typeof tier_type != "undefined" && tier_type == "item"){
    update_number_with_item();
  }


}

async function init_cart_bar(cart_total) {



if(CU(cart_target).length){

  // remove if already present
  CU(".CU_target_cart").remove();
  CU(cart_target).before("<div class='"+ wrapper_target +"'>" + app_html + "</div>");  
  await set_cart_bar(group, "." + wrapper_target, cart_total);

  if(window.location.href.indexOf("/cart") > -1){
    await create_product_slider();  
  }
  if(shop_url=="mollieandfred.myshopify.com"){
  CU("#container-slider").hide();
  }


}

// var num_cart_total = Number(cart_total);

manage_gift_in_cart(cart_total);
}

function set_bar_template(design) {

var f_color = design.foreground_color.replaceAll("'","#");

var b_color = design.background_color.replaceAll("'","#")

var is_gradient = design.is_gradient;

var template_name = design.template_name;

if(template_name == "Rainbow Breeze"){
  CU("#CU_container .bar_container").addClass("rainbow_breeze");
}else if(template_name == "Blue Sky"){
  CU("#CU_container .bar_container").addClass("blue_sky");
}else{
  CU("#CU_container .animated-progress").css({
    "background-color": b_color
  });
  
  CU("#CU_container .icon_wrapper .icon").css({
    "border": "2px solid " + f_color,
    "background": "#FFFFFF"
  })

  CU("#CU_container .icon_wrapper .icon svg").css({
      "fill": f_color
  });

  // after fade-in
  CU("#CU_container .progress-blue span, #CU_container .icon_wrapper .icon.fade_in").css({
      "background": f_color
  });

  if(is_gradient){
    CU("#CU_container .progress-blue span, #CU_container .icon_wrapper .icon.fade_in").css({
      "background": "linear-gradient(45deg, color-mix(in srgb, " + f_color + " 50%, white),"+ f_color +")"
    });
  }
  
  CU("#CU_container .icon_wrapper .icon.fade_in svg").css({
      "fill": "#FFFFFF",
  });    
}

}

function create_bar_message(group, cart_total){

  var num_cart_total = cart_total;
  
  var bar_message = '';
  
  var top_goal = Math.max.apply(Math, group.content.map(function(o) { return o.tier_goal; }))

 
  
  var top_goal = Number((top_goal * current_currency_price).toFixed(2));
  
  for(var tier of group.content) {
  
    var new_goal =  Number((tier.tier_goal * current_currency_price).toFixed(2));
  
  
  
    var price_with_currency = "<span class='cu_price'>" + currency_format.replace("{{amount}}", (new_goal - cart_total).toFixed(2)) + "</span>";
    if(curr_for=="amount_with_comma_separator"){
      price_with_currency = "<span class='cu_price'>" + currency_format.replace("{{amount_with_comma_separator}}", (new_goal- cart_total).toFixed(2)) + "</span>";
    }else if(curr_for == "amount_no_decimals"){
      price_with_currency = "<span class='cu_price'>" + currency_format.replace("{{amount_no_decimals}}", (new_goal - cart_total).toFixed(2)) + "</span>";
  
    }else if(curr_for=="amount_no_decimals_with_comma_separator"){
       price_with_currency = "<span class='cu_price'>" + currency_format.replace("{{amount_no_decimals_with_comma_separator}}", (new_goal - cart_total).toFixed(2)) + "</span>";
    }
    if(num_cart_total < new_goal){
  
  
      bar_message = tier.tier_progress_message.replace(/{amount}/g, price_with_currency);
  
    
    
  
  
      if(curr_for=="amount_with_comma_separator"){
       tier.tier_progress_message = tier.tier_progress_message.replace("{amount}", "{amount_with_comma_separator}");
  
    
  
  
      bar_message = tier.tier_progress_message.replace(/{amount_with_comma_separator}/g, price_with_currency);
  
  
      }else if(curr_for == "amount_no_decimals"){
        
          tier.tier_progress_message = tier.tier_progress_message.replace("{amount}", "{amount_no_decimals}");
    
        bar_message = tier.tier_progress_message.replace(/{amount_no_decimals}/g, price_with_currency);
  
      }else if(curr_for=="amount_no_decimals_with_comma_separator"){

          tier.tier_progress_message = tier.tier_progress_message.replace("{amount}", "{amount_no_decimals_with_comma_separator}");
    
        bar_message = tier.tier_progress_message.replace(/{amount_no_decimals_with_comma_separator}/g, price_with_currency);
  
      }
  
      
  
     
  
  
      
      break;
    }else if(new_goal == num_cart_total){
      bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{amount}/g, price_with_currency) + "</span>";
  
      if(curr_for=="amount_with_comma_separator"){
     tier.tier_progress_message = tier.tier_progress_message.replace("{amount}", "{amount_with_comma_separator}");
  
        bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{amount_with_comma_separator}/g, price_with_currency) + "</span>";
      }else if(curr_for == "amount_no_decimals"){
        bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{amount_no_decimals}/g, price_with_currency) + "</span>";
  
      }else if(curr_for=="amount_no_decimals_with_comma_separator"){
          tier.tier_progress_message = tier.tier_progress_message.replace("{amount}", "{amount_no_decimals_with_comma_separator}");
        bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{amount_no_decimals_with_comma_separator}/g, price_with_currency) + "</span>";
      }
  
  
      break;
    }else if(num_cart_total > top_goal && top_goal == new_goal){
      bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{amount}/g, price_with_currency) + "</span>";
  
  
      if(curr_for=="amount_with_comma_separator"){
           tier.tier_progress_message = tier.tier_progress_message.replace("{amount}", "{amount_with_comma_separator}");
        bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{amount_with_comma_separator}/g, price_with_currency) + "</span>";
      }else if(curr_for == "amount_no_decimals"){
  
       tier.tier_progress_message = tier.tier_progress_message.replace("{amount}", "{amount_no_decimals}");
  
        bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{amount_no_decimals}/g, price_with_currency) + "</span>";
  
      }else if(curr_for=="amount_no_decimals_with_comma_separator"){

       tier.tier_progress_message = tier.tier_progress_message.replace("{amount}", "{amount_no_decimals_with_comma_separator}");
  
        bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{amount_no_decimals_with_comma_separator}/g, price_with_currency) + "</span>";
  
      }
      break;
    }
    
    
  };
  
  return bar_message;
  
  }

async function set_cart_bar(group, target= "", cart_total) {

total_bar_width = CU(target + " .bar_container").width();

console.log(total_bar_width);

if(total_bar_width==0){
  if(screen.width<700){
    
     total_bar_width = 300;  
  }else{
     total_bar_width = 475;  
     if(shop_url=="mollieandfred.myshopify.com"){
      total_bar_width = 425;
    }
  }
 
}

if(shop_url=="63d1ce.myshopify.com"){
if(total_bar_width==0 || total_bar_width < 300){
  if(screen.width<700){
     total_bar_width = 310;  
  }else{
     total_bar_width = 425;  
  }
 
}
}


top_goal = Math.max.apply(Math, group.content.map(function(o) { return o.tier_goal; }))
mean_width = total_bar_width/top_goal;


top_goal = Number((top_goal * current_currency_price).toFixed(2));
// var num_cart_total = Number(cart_total);

group.content.forEach((tier) => {

  var tier_goal = Number((tier.tier_goal * current_currency_price).toFixed(2));

  var icon_placement = (mean_width * tier_goal) - 70;

  var tier_progress_message = tier.tier_progress_message;

  var tier_complete_message = tier.tier_goal_reach_message;

  var tier_goal_currency = currency_format.replace("{{amount}}", tier_goal);

  if(curr_for=="amount_with_comma_separator"){
    tier_goal_currency = currency_format.replace("{{amount_with_comma_separator}}", tier_goal);
  }else if(curr_for == "amount_no_decimals"){
    tier_goal_currency = currency_format.replace("{{amount_no_decimals}}", tier_goal);
  }else if(curr_for=="amount_no_decimals_with_comma_separator"){
    tier_goal_currency = currency_format.replace("{{amount_no_decimals_with_comma_separator}}", tier_goal);
  }
  
  switch(tier.tier_type) {
      
    case "free_shipping":

      var icon_html = CU(target + " #shipping_icon_template").html();

   
      
      var icon_text = CU(icon_html).find(".icon_shipping_text").html(tier.tier_description).end()[0].outerHTML;

      var icon_final_text = CU(icon_text).find(".icon_shipping_goal_text").html(tier_goal_currency).end()[0].outerHTML;
      
      break;

    case "gift":
      
      var icon_html = CU(target + " #gift_icon_template").html();

   
      
      var icon_text = CU(icon_html).find(".icon_gift_text").html(tier.tier_description).end()[0].outerHTML;

      var icon_final_text = CU(icon_text).find(".icon_gift_goal_text").html(tier_goal_currency).end()[0].outerHTML;
      
      break;
      
    case "percentage_discount":

      var icon_html = CU(target + " #discount_icon_template").html();

      var icon_text = CU(icon_html).find(".icon_discount_text").html(tier.tier_description).end()[0].outerHTML;

      var icon_final_text = CU(icon_text).find(".icon_discount_goal_text").html(tier_goal_currency).end()[0].outerHTML;

      break;
      
    case "fixed_discount":

      var icon_html = CU(target + " #discount_icon_template").html();

      var icon_text = CU(icon_html).find(".icon_discount_text").html(tier.tier_description).end()[0].outerHTML;

      var icon_final_text = CU(icon_text).find(".icon_discount_goal_text").html(tier_goal_currency).end()[0].outerHTML;
      
      break
      
  }

  var icom_html_with_loc = CU(icon_final_text).css("left", icon_placement)
  
  CU(target + " .icon_wrapper").append(icom_html_with_loc);

});

await set_progress_bar(Number(cart_total), target);

}

async function set_progress_bar(cart_total, target="") {

var bar_total = (cart_total * mean_width) - 20;

set_bar_message(cart_total);

if(bar_total >= total_bar_width){
  CU(target + " .animated-progress span").attr("data-progress", total_bar_width);
}else{
  CU(target + " .animated-progress span").attr("data-progress", bar_total);  
}


CU(target + " .animated-progress span").each(function () {
  CU(target + " .animated-progress span").animate(
    {
      width: CU(this).attr("data-progress") + "px",
    },
    {
      duration: 1000,
      step: function(currentStep){

        CU(target + ' .icon_wrapper .icon_container .icon').each(function(i, obj) {
            var icon_left = CU(this).parent(".icon_container").css("left").replace("px", "");

            if((Math.round(currentStep)-50) >= Math.round(icon_left)){
              CU(this).addClass("fade_in");
            }else{
              CU(this).removeClass("fade_in");
            }
            set_bar_template(group.design);
        });
        
      },
      complete: function(params) {
        
      }
    }
  );
});
}

function update_number_with_item(){
  document.querySelectorAll('.icon_goal_text, .cu_price').forEach(element => {
    const numberMatch = element.textContent.match(/\d+/);
    if (numberMatch) {
      const number = parseInt(numberMatch[0], 10);

      
      var itemsText = `${number} item${number > 1 ? 's' : ''}`;

      if(shop_url=="eacc0b-2.myshopify.com"){
          itemsText = `${number} Lentes${number > 1 ? '' : ''}`;
      }

      if(shop_url=="mollieandfred.myshopify.com"){
        itemsText = `Buy ${number} item${number > 1 ? 's' : ''}`;

      }

      if(shop_url=="jt9t3d-vv.myshopify.com"){
         itemsText = `${number} piezas${number > 1 ? '' : ''}`;
      }
     
      element.textContent = itemsText;
    }
  });
}

function set_bar_message(cart_total){

var bar_message = create_bar_message(group, cart_total);

if(CU(".CU_free_shipping_bar_title").length){
  CU(".CU_free_shipping_bar_title").html(bar_message);
}

if(CU("#CU_container .bar_heading").length){
  CU("#CU_container .bar_heading").html(bar_message);
}

if(CU(".CU_target_product").length){
  CU(".CU_target_product").html(bar_message);
}

}

window.addEventListener("cart_changed", e => {

var cart_data = e.detail;

if(typeof tier_type != "undefined" && tier_type == "item"){
  var cart_total = cart_data.item_count;
}else{
  var cart_total = cart_data.original_total_price/100;    
}
if(shop_url=="firstmfgco.myshopify.com"){
  cart_total = cart_data.total_price;
}

var cart_data = e.detail;
var cart_total;

// Normal logic
if (typeof tier_type != "undefined" && tier_type == "item") {
  cart_total = cart_data.item_count;
} else {
  cart_total = cart_data.original_total_price / 100; // convert cents → dollars
}

// Special case for firstmfgco
if (shop_url == "firstmfgco.myshopify.com") {
  cart_total = cart_data.total_price;
}

// Special case for www-metoyou-com.myshopify.com
if (shop_url == "www-metoyou-com.myshopify.com") {
  // Loop over items and subtract cost of NM-preorder items
  cart_data.items.forEach(item => {
    if (item.properties?.Type === "NM-preorder") {

      CU("#CU_container").hide();
      // Subtract this product's total line price
      cart_total -= (item.final_line_price / 100); // Shopify returns price in cents
    }
  });
}

if(window.location.href.indexOf("/cart") > -1){
  
  set_progress_bar(cart_total);
  set_bar_message(cart_total);
  manage_gift_in_cart(cart_total);
  
  if (typeof tier_type != "undefined" && tier_type == "item") {
    update_number_with_item();
  }
  
  
}else{
  setTimeout(function(){
    init_cart_bar(cart_total);

    if(typeof tier_type != "undefined" && tier_type == "item"){
      update_number_with_item();
    }
  }, 200);
}


});


//this function removes the previous gift if new gift goal is reached and allow user to remove gift from cart if required
async function manage_gift_in_cart(cart_total) {
  console.log(group.content);

  const sortedTiers = group.content
    .filter(tier => tier.tier_type === "gift" && tier.gift_object?.id)
    .sort((a, b) => a.tier_goal - b.tier_goal);

  if (!sortedTiers.length) return;

  const newCart = await fetchCart();

  // Load and clean stored gifts
  let storedGifts = (getFromLocalStorage("CU_gifts") || [])
    .flat() // flatten in case something nested was stored earlier
    .filter(g => g && newCart.items.some(i => i.id === g.variant_id));

  saveToLocalStorage("CU_gifts", storedGifts);

  let activeGiftTier = 0;
  let updated = false;

  for (let i = 0; i < sortedTiers.length; i++) {
    const tier = sortedTiers[i];
    const nextTier = sortedTiers[i + 1];
    const tierGoal = +(tier.tier_goal * current_currency_price).toFixed(2);
    const variantId = tier.tier_gift_variant_id;

    const giftInCart = newCart.items.some(i => i.id === variantId);
    const giftStored = storedGifts.some(g => g.variant_id === variantId);

    const qualifies = cart_total >= tierGoal && (!nextTier || cart_total < nextTier.tier_goal);

    if (qualifies) {
      if (!giftInCart && !giftStored) {
        storedGifts.push({ variant_id: variantId });
        updated = true;
        add_to_cart("", variantId);
      }
      activeGiftTier = tierGoal;
    } else if (giftInCart) {
      storedGifts = storedGifts.filter(g => g.variant_id !== variantId);
      updated = true;
      remove_from_cart(variantId);
    }
  }

  // Save only if something changed, and only if it’s not empty
  if (updated) {
    if (storedGifts.length > 0) {
      saveToLocalStorage("CU_gifts", storedGifts);
    } else {
      localStorage.removeItem("CU_gifts");
    }
  }

}
function getFromLocalStorage(key) {
  try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : [];
  } catch (error) {
      console.error("Error reading from localStorage:", error);
      return [];
  }
}


function isVariantIdPresent(key, variantId) {
  // Retrieve existing data from local storage
  const existingData = localStorage.getItem(key);
  if (existingData) {
      // Parse the data
      const parsedData = JSON.parse(existingData);
      // Ensure the parsed data is an array
      const dataArray = Array.isArray(parsedData) ? parsedData : [parsedData];
      // Check if the variant_id exists in the array
      return dataArray.some(item => item.variant_id === variantId);
  }
  // If no data in local storage, return false
  return false;
}
function removeVariantId(key, variantId) {
// Retrieve existing data from local storage
const existingData = localStorage.getItem(key);
if (existingData) {
    // Parse the data
    const parsedData = JSON.parse(existingData);
    // Ensure the parsed data is an array
    const dataArray = Array.isArray(parsedData) ? parsedData : [parsedData];
    // Filter out the entry with the specified variant_id
    const updatedData = dataArray.filter(item => item.variant_id !== variantId);
    // Save the updated data back to local storage
    localStorage.setItem(key, JSON.stringify(updatedData));
    console.log(`Variant ID ${variantId} has been removed.`);
} else {
    console.log("No data found in local storage.");
}
}
function saveToLocalStorage(key, object) {
  // Retrieve existing data from local storage
  const existingData = localStorage.getItem(key);
  let updatedData;
  if (existingData) {
      // Parse existing data if it's already there
      const parsedData = JSON.parse(existingData);
      // Ensure existing data is an array
      const dataArray = Array.isArray(parsedData) ? parsedData : [parsedData];
      // Append the new object to the existing data
      dataArray.push(object);
      // Update data to save
      updatedData = dataArray;
  } else {
      // If no existing data, save the object in an array
      updatedData = [object];
  }
  // Save the updated data back to local storage
  localStorage.setItem(key, JSON.stringify(updatedData));
}





  async function fetchCart() {
  const response = await fetch('/cart.js');
  return response.json();
  }

async function emitCartChanges() {
  const newCart = await fetchCart();
  const event = new CustomEvent("cart_changed", { detail: newCart });
  window.dispatchEvent(event);
}

function observeCartChanges() {
  const cartObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      //console.log(entry);
      const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
      const isCartChangeRequest = /\/cart\//.test(entry.name);
      if (isValidRequestType && isCartChangeRequest) {
        emitCartChanges();
      }
    });
  });

  cartObserver.observe({ entryTypes: ["resource"] });
}

async function create_product_slider(){

var s_products = JSON.parse(products_data);
var slides = '';

if(s_products.upsell_type == "specific_products"){
  
  s_products.productItems.pop();

  CU.each( s_products.productItems, function( key, product ) {
  
    slides += '<li class="carousel-item splide__slide"><div class="product-item-card"><div class="left-side"><a href="products/'+ product.handle +'"><img src="'+ product.image +'" alt="'+ product.title +'"></a></div><div class="right-side"><a href="products/'+ product.handle +'"><div class="title_card">'+ product.title +'</div><div class="price_card">'+ product.price_with_money +'</div></a></div><div class="button_container"><a onclick="add_to_cart(this)" data-variant-id="'+ product.variant_id +'" class="cu_button">'+ add_to_cart_tex +'</a></div></div></li>'
  
  }); 
  
  CU(".splide__list").html(slides);

  
}else if(s_products.upsell_type == "recommended_products"){
  
  const newCart = await fetchCart();

  if(newCart.item_count >= 1){
    
    var r_product_id = newCart.items[0].product_id;
    
    await fetch(window.Shopify.routes.root + "recommendations/products.json?product_id="+ r_product_id)
    .then(response => response.json())
    .then(({ products }) => {
      console.log(products);
      CU.each( products, function( key, product ) {

        var p_c = currency_format.replace("{{amount}}", (product.price/100).toFixed(2));

        if(curr_for=="amount_with_comma_separator"){
          p_c = currency_format.replace("{{amount_with_comma_separator}}", (product.price/100).toFixed(2));
        }else if(curr_for == "amount_no_decimals"){
          p_c = currency_format.replace("{{amount_no_decimals}}", (product.price/100).toFixed(2));
        }

        var price_with_currency = p_c;
  
        slides += '<li class="carousel-item splide__slide"><div class="product-item-card"><div class="left-side"><img src="'+ product.featured_image +'" alt="'+ product.title +'"></div><div class="right-side"><div class="title_card">'+ product.title +'</div><div class="price_card">'+ price_with_currency +'</div></div><div class="button_container"><a class="cu_button" data-variant-id="'+ product.variants[0].id +'" onclick="add_to_cart(this)">'+ add_to_cart_tex +'</a></div></div></li>'
  
      });  
      
      CU(".splide__list").html(slides);
  
    });
  } 
}


if(s_products.upsell_type != "none"){
  setTimeout(activate_slider, 500);
}

}

function activate_slider(){
var splide = new Splide( '.splide', {
      type   : 'loop',
      perPage: 3,
      perMove: 1,
      pagination: false,
      gap: 30,
      padding: 15,
      breakpoints: {
        840: {
          perPage: 1,
        },
      }
    } );
  
splide.mount();
}

function remove_from_cart(variant_id) {
  // Skip if a previous remove error exists for this variant
  if (hasGiftError(variant_id, "remove")) {
    console.warn("Skipping gift remove due to previous error:", variant_id);
    return;
  }

  const updates = { [variant_id]: 0 };

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  })
    .then(response => {
      if (!response.ok) throw new Error(`Remove failed: ${response.status}`);
      clearGiftError(variant_id, "remove");
      localStorage.setItem("drawer", "true");
      window.location.reload(true);
    })
    .catch(error => {
      console.error('Gift remove error:', error);
      markGiftError(variant_id, "remove");
    });
}

function add_to_cart(th, variant_id = '') {
  if (!variant_id) variant_id = CU(th).data("variant-id");

  // Skip if a previous add error exists for this variant
  if (hasGiftError(variant_id, "add")) {
    console.warn("Skipping gift add due to previous error:", variant_id);
    return;
  }

  const formData = { items: [{ id: variant_id, quantity: 1 }] };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (!response.ok) throw new Error(`Add failed: ${response.status}`);
      clearGiftError(variant_id, "add");
      localStorage.setItem("drawer", "true");
      window.location.reload(true);
    })
    .catch(error => {
      console.error('Gift add error:', error);
      markGiftError(variant_id, "add");
    });
}
function markGiftError(variant_id, action) {
  const errors = JSON.parse(localStorage.getItem("CU_gift_errors") || "[]");
  const alreadyLogged = errors.some(e => e.variant_id === variant_id && e.action === action);
  if (!alreadyLogged) {
    errors.push({ variant_id, action, timestamp: Date.now() });
    localStorage.setItem("CU_gift_errors", JSON.stringify(errors));
  }
}

function hasGiftError(variant_id, action) {
  const errors = JSON.parse(localStorage.getItem("CU_gift_errors") || "[]");
  return errors.some(e => e.variant_id === variant_id && e.action === action);
}

function clearGiftError(variant_id, action) {
  let errors = JSON.parse(localStorage.getItem("CU_gift_errors") || "[]");
  errors = errors.filter(e => !(e.variant_id === variant_id && e.action === action));
  if (errors.length > 0) localStorage.setItem("CU_gift_errors", JSON.stringify(errors));
  else localStorage.removeItem("CU_gift_errors");
}




 

 